import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class InvoiceSummaryService {


    url: string;
    constructor(private http: HttpClient, @Inject("BASE_URL") baseUrl: string) {
        this.url = baseUrl;

        if (this.url.charAt(this.url.length - 1) == "/")
            this.url = this.url.substring(0, this.url.length - 1);
    }


    getInvoiceList(request: any): Observable<any> {
        return this.http.post<any>(`${this.url}/api/InvoiceSummary/invoice-list`, request);
    }


    getInvoiceUploadedList(request: any): Observable<any> {
        return this.http.post<any>(`${this.url}/api/InvoiceSummary/invoice-uploaded-list`, request);
    }


    submitInvoice(request: any): Observable<any> {
        return this.http.post<any>(`${this.url}/api/InvoiceSummary/submit-invoice`, request);
    }


    getInvoiceHistory(invoiceId: number): Observable<any> {
        return this.http.get<any>(`${this.url}/api/InvoiceSummary/invoice-history/${invoiceId}`);
    }


    updateInvoiceStatus(request: any): Observable<any> {
        return this.http.post<any>(`${this.url}/api/InvoiceSummary/invoice-change-status`, request);
    }


    getInvoiceDetails(invoiceId: number): Observable<any> {
        return this.http.get<any>(`${this.url}/api/InvoiceSummary/invoice-details/${invoiceId}`);
    }

 
    reuploadInvoice(request: any): Observable<any> {
        return this.http.post<any>(`${this.url}/api/InvoiceSummary/reupload-invoice`, request);
    }

  
    getSupportingDocuments(invoiceId: number): Observable<any> {
        return this.http.get<any>(`${this.url}/api/InvoiceSummary/supporting-documents/${invoiceId}`);
    }


    saveSupportingDocuments(request: any): Observable<any> {
        return this.http.post<any>(`${this.url}/api/InvoiceSummary/save-supporting-documents`, request);
    }

   // Export pending invoices
exportInvoiceSummary(request: any): Observable<Blob> {
  return this.http.post<Blob>(
    `${this.url}/api/invoiceSummary/ExportInvoiceSearchSummary`,
    request,
    { responseType: 'blob' as 'json' }
  );
}

// Export uploaded invoices
exportInvoiceUploadedSummary(request: any): Observable<Blob> {
  return this.http.post<Blob>(
    `${this.url}/api/invoiceSummary/ExportInvoiceUploadedSummary`,
    request,
    { responseType: 'blob' as 'json' }
  );
}
}
